import { takeLatest } from 'redux-saga/effects';
import {
  // Training Class
  getTrainingClassListSuccess, getTrainingClassListFail,
  getTrainingClassDetailsSuccess, getTrainingClassDetailsFail,

  // Class Module
  getTrainingClassModuleListSuccess, getTrainingClassModuleListFail,
  getTrainingClassModuleDetailsSuccess, getTrainingClassModuleDetailsFail,

  // Class Participant
  getTrainingClassParticipantListSuccess, getTrainingClassParticipantListFail,
  getTrainingClassParticipantDetailsSuccess, getTrainingClassParticipantDetailsFail,

  // Class Result
  getTrainingModuleResultListSuccess, getTrainingModuleResultListFail,
  getTrainingModuleResultDetailsSuccess, getTrainingModuleResultDetailsFail,
} from './trainingClassState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';


const crudService = createCrudService('api/v1/training/training-classes');
const redirectData = { route: '/console/training-classes', mode: 'list', recordId: 0 };
const modelName = 'Training Class';
const modelId = 'tcl_id';

function* getTrainingClassList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getTrainingClassListSuccess, 
		getTrainingClassListFail, 
		null, 
		null, 
		LOADING_MSG
	);
}

function* getTrainingClassDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getTrainingClassDetailsSuccess, 
		getTrainingClassDetailsFail, 
		null, 
		null, 
		LOADING_MSG
	);		
}

function* doTrainingClassCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getTrainingClassDetailsSuccess, 
		getTrainingClassDetailsFail,
		createRecordSuccess('Training Class'),
		{ ...redirectData, mode: 'reload' },
		SAVING_MSG
	);
}

function* doTrainingClassUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload.tcl_id, data.payload), 
		getTrainingClassDetailsSuccess, 
		getTrainingClassDetailsFail,
		updateRecordSuccess('Training Class'),
		{ ...redirectData, mode: 'reload' },
		UPDATING_MSG
	);	
}

function* doTrainingClassDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getTrainingClassDetailsSuccess, 
		getTrainingClassDetailsFail,
		deleteRecordSuccess('Training Class'),
		{ ...redirectData, mode: data.payload.mode },
		DELETING_MSG
	);	
}

//

function* getTrainingClassModuleList(data) {
	const { classeId } = data.payload;
	const childEndpoint = `${classeId}/training-class-modules`;
	yield doCrudCall(
		() => crudService.getList(data.payload, childEndpoint), 
		getTrainingClassModuleListSuccess, 
		getTrainingClassModuleListFail, null, null, LOADING_MSG
	);
}
	

function* getTrainingClassModuleDetails(data) {
	const { classeId, moduleId } = data.payload;
		const childEndpoint = `${classeId}/training-class-modules`;
		yield doCrudCall(
			() => crudService.getDetails(moduleId, childEndpoint), 
			getTrainingClassModuleDetailsSuccess, 
			getTrainingClassModuleDetailsFail, null, null, LOADING_MSG	
	);
}

function* doTrainingClassModuleCreate(data){
	const { tcm_class_id: classeId }= data.payload;
	const childEndpoint = `${classeId}/training-class-modules`;
		yield doCrudCall(
			() => crudService.doCreate(data.payload, childEndpoint), 
			getTrainingClassModuleDetailsSuccess, 
			getTrainingClassModuleDetailsFail, 
			createRecordSuccess(modelName),
			{...redirectData, mode: "reload" },
			SAVING_MSG	
	);
}

function* doTrainingClassModuleUpdate(data){
	const { tcm_class_id: classeId, tcm_id } = data.payload;
	const childEndpoint = `${classeId}/training-class-modules`;
	yield doCrudCall(
		() => crudService.doUpdate(tcm_id, data.payload, childEndpoint), 
		getTrainingClassModuleDetailsSuccess, 
		getTrainingClassModuleDetailsFail, 
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG	
	);
}

function* doTrainingClassModuleDelete(data){
	const { tcm_class_id:classeId, tcm_id } = data.payload;
	const childEndpoint = `${classeId}/training-class-modules`;
	yield doCrudCall(
		() => crudService.doDelete(tcm_id, childEndpoint), 
		getTrainingClassModuleDetailsSuccess, 
		getTrainingClassModuleDetailsFail, 
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		DELETING_MSG	
	);
}

//

function* getTrainingClassParticipantList(data) {
	const { classeId } = data.payload;
	const childEndpoint = `${classeId}/training-class-participants`;
	yield doCrudCall(
		() => crudService.getList(data.payload, childEndpoint),
		getTrainingClassParticipantListSuccess,
		getTrainingClassParticipantListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getTrainingClassParticipantDetails(data) {
	const { classeId, participantId } = data.payload;
	const childEndpoint = `${classeId}/training-class-participants`;
	yield doCrudCall(
		() => crudService.getDetails(participantId, childEndpoint),
		getTrainingClassParticipantDetailsSuccess,
		getTrainingClassParticipantDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doTrainingClassParticipantCreate(data) {
	const { tcp_class_id: classeId } = data.payload;
	const childEndpoint = `${classeId}/training-class-participants`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint),
		getTrainingClassParticipantDetailsSuccess,
		getTrainingClassParticipantDetailsFail,
		createRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		SAVING_MSG
	);
}

function* doTrainingClassParticipantUpdate(data) {
	const { tcp_class_id: classeId, tcp_id } = data.payload;
	const childEndpoint = `${classeId}/training-class-participants`;
	yield doCrudCall(
		() => crudService.doUpdate(tcp_id, data.payload, childEndpoint),
		getTrainingClassParticipantDetailsSuccess,
		getTrainingClassParticipantDetailsFail,
		updateRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		UPDATING_MSG
	);
}

function* doTrainingClassParticipantDelete(data) {
	const { tcp_class_id: classeId, tcp_id } = data.payload;
	const childEndpoint = `${classeId}/training-class-participants`;
	yield doCrudCall(
		() => crudService.doDelete(tcp_id, childEndpoint),
		getTrainingClassParticipantDetailsSuccess,
		getTrainingClassParticipantDetailsFail,
		deleteRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		DELETING_MSG
	);
}


//

function* getTrainingModuleResultList(data) {
	const { classeId } = data.payload;
	const childEndpoint = `${classeId}/training-module-results`;

	yield doCrudCall(
		() => crudService.getList(data.payload, childEndpoint),
		getTrainingModuleResultListSuccess,
		getTrainingModuleResultListFail,
		null,
		null,
		LOADING_MSG
	);
}


function* getTrainingModuleResultDetails(data) {
	const { classeId, id } = data.payload;
	const childEndpoint = `${classeId}/training-module-results/${id}`;
	yield doCrudCall(
		() => crudService.getDetails(data.payload, childEndpoint),
		getTrainingModuleResultDetailsSuccess,
		getTrainingModuleResultDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}


function* doTrainingModuleResultCreate(data) {
	const { classeId } = data.payload;
	const childEndpoint = `${classeId}/training-module-results`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint),
		getTrainingModuleResultDetailsSuccess,
		getTrainingModuleResultDetailsFail,
		createRecordSuccess('Class Result'),
		{ ...redirectData, mode: "reload" },
		null,
		SAVING_MSG
	);
}


function* doTrainingModuleResultUpdate(data) {
	const { classeId, trs_id } = data.payload; 
	const childEndpoint = `${classeId}/training-module-results/${trs_id}`;
	yield doCrudCall(
		() => crudService.doUpdate(trs_id, data.payload, childEndpoint),
		getTrainingModuleResultDetailsSuccess,
		getTrainingModuleResultDetailsFail,
		updateRecordSuccess('Class Result'),
		{ ...redirectData, mode: "reload" },
		UPDATING_MSG
	);
}


function* doTrainingModuleResultDelete(data) {
	const { classeId, recordId } = data.payload; 
	const childEndpoint = `${classeId}/training-module-results/${recordId}`;

	yield doCrudCall(
		() => crudService.doDelete(recordId, childEndpoint),
		getTrainingModuleResultDetailsSuccess,
		getTrainingModuleResultDetailsFail,
		deleteRecordSuccess('Class Result'),
		{...redirectData, mode: "reload" },
		DELETING_MSG
	);
}



function* trainingClassSaga() {
	// Training Class
	yield takeLatest('trainingClass/getTrainingClassList', getTrainingClassList);
	yield takeLatest('trainingClass/getTrainingClassDetails', getTrainingClassDetails);
	yield takeLatest('trainingClass/doTrainingClassCreate', doTrainingClassCreate);
	yield takeLatest('trainingClass/doTrainingClassUpdate', doTrainingClassUpdate);
	yield takeLatest('trainingClass/doTrainingClassDelete', doTrainingClassDelete);

	// Class Module
	yield takeLatest('trainingClass/getTrainingClassModuleList', getTrainingClassModuleList);
	yield takeLatest('trainingClass/getTrainingClassModuleDetails', getTrainingClassModuleDetails);
	yield takeLatest('trainingClass/doTrainingClassModuleCreate', doTrainingClassModuleCreate);
	yield takeLatest('trainingClass/doTrainingClassModuleUpdate', doTrainingClassModuleUpdate);
	yield takeLatest('trainingClass/doTrainingClassModuleDelete', doTrainingClassModuleDelete);

	// Class Participant
	yield takeLatest('trainingClass/getTrainingClassParticipantList', getTrainingClassParticipantList);
	yield takeLatest('trainingClass/getTrainingClassParticipantDetails', getTrainingClassParticipantDetails);
	yield takeLatest('trainingClass/doTrainingClassParticipantCreate', doTrainingClassParticipantCreate);
	yield takeLatest('trainingClass/doTrainingClassParticipantUpdate', doTrainingClassParticipantUpdate);
	yield takeLatest('trainingClass/doTrainingClassParticipantDelete', doTrainingClassParticipantDelete);

	// Class Result
	yield takeLatest('trainingClass/getTrainingModuleResultList', getTrainingModuleResultList);
	yield takeLatest('trainingClass/getTrainingModuleResultDetails', getTrainingModuleResultDetails);
	yield takeLatest('trainingClass/doTrainingModuleResultCreate', doTrainingModuleResultCreate);
	yield takeLatest('trainingClass/doTrainingModuleResultUpdate', doTrainingModuleResultUpdate);
	yield takeLatest('trainingClass/doTrainingModuleResultDelete', doTrainingModuleResultDelete);
}

export default trainingClassSaga;
